import styled from 'styled-components';
import tw from 'twin.macro';

const ServiceContractContainer = styled.div`
  ${tw`border border-gray-300 p-4 mb-4 border-solid`}
`;

const Title = styled.div`
  ${tw`font-bold text-sm mb-3`}
`;

const CompanySection = styled.div`
  ${tw`mb-4`}
`;

const CompanyRow = styled.div`
  ${tw`flex items-center gap-2 mb-2`}
`;

const Label = styled.span`
  ${tw`text-sm w-24`}
`;

const Input = styled.input`
  ${tw`border-b border-gray-400 w-[50px] border-none`}
`;

const TermRow = styled.div`
  ${tw`flex items-center gap-2`}
`;

const SignatureSection = styled.div`
  ${tw`mt-10`}
`;

const SignatureLine = styled.div`
  ${tw`border-b border-gray-600 w-48 mt-1`}
`;

const OptionalServiceContractComponent = () => {
  return (
    <ServiceContractContainer>
      <Title>
        OPTIONAL SERVICE CONTRACT(S) You want to purchase the service contract(s) written with the
        following company(ies) for the term(s) shown below for the charge(s) shown in item 1I.
      </Title>

      {[1, 2, 3, 4, 5].map(num => (
        <CompanySection key={num}>
          <CompanyRow>
            <Label>I{num} Company</Label>
            <Input type="text" defaultValue="N/A" />
          </CompanyRow>
          <TermRow>
            <Label>Term</Label>
            <Input type="text" className="w-16" defaultValue="N/A" />
            <span className="text-sm">Mos. or</span>
            <Input type="text" className="w-16" defaultValue="N/A" />
            <span className="text-sm">miles</span>
          </TermRow>
        </CompanySection>
      ))}

      <SignatureSection>
        <Label>Buyer X: _______________________</Label>
        <SignatureLine />
      </SignatureSection>
    </ServiceContractContainer>
  );
};

export default OptionalServiceContractComponent;
